function UncheckedSelectionIndicator() {
  return (
    <div
      aria-hidden="true"
      className="size-6 rounded-sm border-2 border-new-beginnings-base bg-white"
      data-testid="unchecked-selection-indicator"
    />
  );
}

export { UncheckedSelectionIndicator };
